var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "kt-datatable kt-datatable--default kt-datatable--loaded kt-datatable--table"
    },
    [
      _c("table", { staticClass: "kt-datatable__table" }, [
        _c("thead", { staticClass: "kt-datatable__head" }, [
          _c(
            "tr",
            { staticClass: "kt-datatable__row" },
            _vm._l(_vm.columns, function(column) {
              return _c(
                "th",
                { key: column.name, staticClass: "kt-datatable__cell" },
                [_c("b", [_vm._v(_vm._s(column.name))])]
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          { staticClass: "kt-datatable__body" },
          [
            _vm._t("beforeRows", null, null, _vm.scopeProps),
            _vm._v(" "),
            _vm._l(_vm.flatennedRows, function(row) {
              return _c(
                "tr",
                { key: row.ID, staticClass: "kt-datatable__row" },
                _vm._l(_vm.columns, function(column) {
                  return _c(
                    "td",
                    { key: column.key, staticClass: "kt-datatable__cell" },
                    [
                      _vm._t(
                        column.key,
                        null,
                        null,
                        Object.assign({}, { row: row }, _vm.scopeProps)
                      )
                    ],
                    2
                  )
                }),
                0
              )
            })
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }